import { functions, httpsCallable } from '@/services/firebase'

interface ScratchCardInitResult {
  gameId: string
  won: boolean
  prize: number
}

interface ScratchCardRevealResult {
  won: boolean
  prize: number
  refId?: string
  claimed: boolean
}

class ScratchCardService {
  private initFn = httpsCallable<{ phoneNumber: string }, ScratchCardInitResult>(functions, 'scratchCardInit')
  private revealFn = httpsCallable<{ gameId: string; phoneNumber: string }, ScratchCardRevealResult>(functions, 'scratchCardReveal')

  async init(phoneNumber: string): Promise<ScratchCardInitResult> {
    if (!phoneNumber) throw new Error('Numéro requis')
    const result = await this.initFn({ phoneNumber })
    if (!result.data) throw new Error('Erreur serveur')
    return result.data
  }

  async reveal(gameId: string, phoneNumber: string): Promise<ScratchCardRevealResult> {
    if (!phoneNumber) throw new Error('Numéro requis')
    if (!gameId) throw new Error('Game ID requis')
    const result = await this.revealFn({ gameId, phoneNumber })
    if (!result.data) throw new Error('Erreur serveur')
    return result.data
  }
}

export const scratchCardService = new ScratchCardService()
